import { CURSOR_OVER } from 'game/constants/Constants.js';

export class XylophoneBubbles extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);
    this.bubbles = [];
    this.bubbleSpawnArea = new Phaser.Geom.Rectangle(910, 390, 1000, 400);
  }

  updateBubbles(delta) {
    delta /= 1000;
    this.each((bubble) => {
      if (bubble.visible) {
        bubble.lifeSpan += delta;
        bubble.y -= bubble.speed * delta;
        if (bubble.y < -300) this.poolBubble(bubble);
      }
    });
  }

  spawnBubble(note, position) {
    let bubble = this.bubbles.find((b) => !b.visible);
    if (!bubble) bubble = this.scene.add.spine(0, 0, 'bubble', 'idle', true);

    bubble.setSkinByName('bubble_' + note);

    bubble.setPosition(
      position ? position.x : 910 + Math.random() * 1000 - 500,
      position ? position.y : 400 + Math.random() * 200
    );
    bubble.setAnimation(0, 'idle', true);
    bubble.speed = 10 + Math.random() * 20;
    bubble.note = note;
    bubble.lifeSpan = 0;
    this.scene.tweens.add({
      targets: bubble,
      scale: { from: 0, to: 0.6 },
      duration: 250,
      ease: Phaser.Math.Easing.Back.Out,
    });
    this.bubbles.push(bubble);
    this.add(bubble);
    this.activateBubble(bubble);
  }

  popAllBubbles() {
    this.each(this.popBubble, this);
  }

  popBubble(bubble) {
    this.deactivateBubble(bubble);
    bubble.setAnimation(0, 'interact', false);
    bubble.once('complete', () => this.poolBubble(bubble));
    this.scene.game.soundController.playSFX('sfx', 'bubble-pop');
  }

  activateBubble(bubble) {
    bubble.visible = true;
    bubble.enabled = true;
    bubble.setInteractive({ cursor: CURSOR_OVER });
    bubble.once('pointerdown', () => this.popBubble(bubble));
  }

  deactivateBubble(bubble) {
    bubble.enabled = false;
    bubble.removeInteractive();
    bubble.removeAllListeners('pointerdown');
  }

  poolBubble(bubble) {
    this.deactivateBubble(bubble);
    bubble.visible = false;
  }
}
